import {
  SIGN_IN_BEGIN,
  SIGN_IN_SUCCESS,
  SIGN_IN_FAILURE,
  SIGN_OUT_BEGIN,
  SIGN_OUT_SUCCESS,
  SIGN_OUT_FAILURE,
  SIGN_UP_BEGIN,
  SIGN_UP_SUCCESS,
  SIGN_UP_FAILURE,
  SAVE_USER_DATA_BEGIN,
  SAVE_USER_DATA_SUCCESS,
  SAVE_USER_DATA_FAILURE,
  SIGN_UP_GUARDIAN_BEGIN,
  SIGN_UP_GUARDIAN_SUCCESS,
  SIGN_UP_GUARDIAN_FAILURE,
  SIGN_IN_GUARDIAN_BEGIN,
  SIGN_IN_GUARDIAN_SUCCESS,
  SIGN_IN_GUARDIAN_FAILURE,
  SIGN_UP_GUARDIAN_INFO_BEGIN,
  SIGN_UP_GUARDIAN_INFO_SUCCESS,
  SIGN_UP_GUARDIAN_INFO_FAILURE
} from "./actions"

const initialState = {
  loading: false,
  isLogged: false,
  user: {},
  regPage2Data: {}
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SIGN_IN_BEGIN:
      return { ...state, loading: true }
    case SIGN_IN_SUCCESS:
      return {
        ...state,
        loading: false,
        isLogged: true,
        user: action.payload.user
      }
    case SIGN_IN_FAILURE:
      return { ...state, loading: false, isLogged: false, user: {} }

    case SIGN_OUT_BEGIN:
      return { ...state, isLogged: true }
    case SIGN_OUT_SUCCESS:
      return { ...state, isLogged: false, user: {} }
    case SIGN_OUT_FAILURE:
      return { ...state, isLogged: false }

    case SIGN_UP_BEGIN:
      return { ...state, loading: true }
    case SIGN_UP_SUCCESS:
      return { ...state, loading: false }
    case SIGN_UP_FAILURE:
      return { ...state, loading: false }

    case SAVE_USER_DATA_BEGIN:
      return { ...state, loading: true }
    case SAVE_USER_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        isLogged: true,
        user: action.payload.user
      }
    case SAVE_USER_DATA_FAILURE:
      return { ...state, loading: false }

    case SIGN_UP_GUARDIAN_BEGIN:
      return { ...state, loading: true }
    case SIGN_UP_GUARDIAN_SUCCESS:
      return { ...state, loading: false }
    case SIGN_UP_GUARDIAN_FAILURE:
      return { ...state, loading: false }

    case SIGN_UP_GUARDIAN_INFO_BEGIN:
      return { ...state, loading: true }
    case SIGN_UP_GUARDIAN_INFO_SUCCESS:
      return { ...state, loading: false, regPage2Data: action.payload.data }
    case SIGN_UP_GUARDIAN_INFO_FAILURE:
      return { ...state, loading: false }

    case SIGN_IN_GUARDIAN_BEGIN:
      return { ...state, loading: true }
    case SIGN_IN_GUARDIAN_SUCCESS:
      return {
        ...state,
        loading: false,
        isLogged: true,
        user: action.payload.user
      }
    case SIGN_IN_GUARDIAN_FAILURE:
      return { ...state, loading: false, isLogged: false, user: {} }

    default:
      return state
  }
}
